import { render, staticRenderFns } from "./data-permission.vue?vue&type=template&id=30a65cf7"
import script from "./data-permission.vue?vue&type=script&lang=js"
export * from "./data-permission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports